/* @flow */

const storage: Object = window.localStorage;

const APP_NAME: string = 'sdrenewables';

function createKey(key: string): string {
  return `${APP_NAME}:${key}`;
}

export default {
  get(key: string): any {
    const fullKey = createKey(key);
    if (!Object.prototype.hasOwnProperty.call(storage, fullKey)) {
      return undefined;
    }
    return JSON.parse(storage.getItem(fullKey));
  },

  set(key: string, value: any) {
    if (value === undefined) {
      this.delete(key);
      return;
    }

    storage.setItem(createKey(key), JSON.stringify(value));
  },

  delete(key: string) {
    storage.removeItem(createKey(key));
  },

  clear() {
    Object.keys(storage).forEach((key) => storage.removeItem(key));
  },
};
